import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Socket, SocketIoConfig } from 'ngx-socket-io';
import { AppSettings } from 'src/app/core/constant';
const config: SocketIoConfig = { url: AppSettings.API_ENDPOINT, options: {path:"/socket.io"} };

@Injectable({
  providedIn: 'root'
})
export class SocketService {
audio : any;
  newVetConsult : boolean = false;
  newVetConsultData : any ; 
  one : any;
  two : any;
  three : any;
  four : any;

  constructor(private socket : Socket , 
              private navCtrl :  NavController) { 
 
    // this.audio = new Audio();
    // this.audio.src = "https://firebasestorage.googleapis.com/v0/b/ilastword.appspot.com/o/Calling.wav?alt=media&token=fbe3cf8f-b6b7-419b-9f37-08ae3a762f4a";
    // this.audio.loop = true;
    // this.audio.load();
    // this.playAudio();

  }
  playAudio(){
     
    this.audio = new Audio('../../../../assets/audio/Calling.wav');
    // this.audio.src = "https://firebasestorage.googleapis.com/v0/b/ilastword.appspot.com/o/Calling.wav?alt=media&token=fbe3cf8f-b6b7-419b-9f37-08ae3a762f4a";
    this.audio.loop = true;
    this.audio.play();
  }
  stopAudio(){
    this.audio.pause();
    this.audio.currentTime = 0;

  }


  connectWithSocket(id){
    console.log("hellossssssssssss")
    this.socket.connect();
    this.socket.emit('join-socket', id);
    // console.log("vet"+id,"vetId")
    this.socket.emit('create-room', "vet"+id);
    this.socket.emit('join-room', "vet"+id , id);

    this.socket.emit('create-room', "vets");
    this.socket.emit('join-room',  "vets" , id);
    this.socket.on('disconnect', function(){
      console.log("socket discionnect ho chuka h ab sambhalo ise")
      // Do stuff (probably some jQuery)
  });
    setTimeout(() => {
      
      this.getSocketMessages(id);
    }, 2000);

  }


  getSocketMessages(id){
    console.log("listening the messages from app component.........................")

   this.one =  this.socket.fromEvent("indirect-msg-to-user" + id).subscribe((message: any) => {
      console.log(message)
    })
  
   this.two = this.socket.fromEvent("vet"+id+"users-changed").subscribe((message: any) => {
     console.log(message)
   })
   this.three = this.socket.fromEvent('vetsusers-changed').subscribe((message: any) => {
     console.log(message);
   })
   this.four = this.socket.fromEvent("vet"+id+"vet_consult").subscribe((message: any) => {
    console.log(message)
    this.newVetConsult = true;
    this.newVetConsultData = message;
    this.playAudio()
  
})
   

  }

  goToConsultlinig(){
    let userData = JSON.parse(localStorage.getItem("userProfile"));
    this.socket.emit('assign_vet' , { room : "user"+this.newVetConsultData.userId,
    consultingId:this.newVetConsultData._id,
    vetId : userData._id,
    vetName : userData.name,
    status : 'VetAccepted'
  });
    this.navCtrl.navigateForward("/remote-consulting/"+this.newVetConsultData._id)
}


cancelConsulting(){
  let userData = JSON.parse(localStorage.getItem("userProfile"));
  let data = {
  consultingId : this.newVetConsultData._id,
  oldVetId : userData._id,
  userId : this.newVetConsultData.userId,
  vetName : userData.name
   };
   console.log(data)
this.socket.emit('consulting_rejected', data);
this.newVetConsult = false;
this.stopAudio();
}
unsubscribeSocket(){
  
  this.one.unsubscribe();
  this.two.unsubscribe();
  this.three.unsubscribe();
  this.four.unsubscribe();

}



}
